const upperFirst = str => (`${str[0].toUpperCase()}${str.slice(1)}`);
const convertToSnakeCase = (str) => {
    if (!str) {
        return str;
    }
    const matchPattern = (/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
    const matchResult = str.match(matchPattern);
    if (!matchResult) {
        return str;
    }
    return matchResult.map(x => x.toLowerCase()).join('_');
};

export { convertToSnakeCase, upperFirst };
//# sourceMappingURL=index.js.map
